import React, { ReactNode } from 'react';

import { paths } from 'client/shared/Paths';
import {
  MarketingAnchor,
  MarketingBoldLink,
} from 'components/MarketingPagesShared/styles';
import { MarketingButton } from 'components/MarketingPagesShared/MarketingButton';
import { useT } from 'client/i18n/hooks/useT';
import { HomeSection } from '../../../styles';
import {
  HomeSignupBackground,
  HomeSignupButton,
  HomeSignupContainer,
  HomeSignupFooter,
  HomeSignupHeader,
  HomeSignupText,
} from './styles';

export function HomeSignup({
  showSwitchLink = true,
  onClickGetStarted,
  onClickSwitch,
  children,
}: {
  showSwitchLink?: boolean;
  onClickGetStarted?: () => void;
  onClickSwitch?: () => void;
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <HomeSignupBackground>
      <HomeSection>
        <HomeSignupContainer>
          <HomeSignupHeader>
            {t(
              'HomePage.HomeSignup.Title',
              'For everyone, everywhere, for free',
              'Anchor home page signup section title'
            )}
          </HomeSignupHeader>
          <HomeSignupText>
            {t(
              'HomePage.HomeSignup.Message',
              "We believe everyone's stories can and should be heard, so we're giving creators around the world—from first-time podcasters to pros—a powerful platform to {shareLink}.",
              'Anchor home page signup section message',
              {
                shareLink: (
                  <MarketingAnchor
                    href={paths.blog.freePodcastingWithAnchor}
                    target="_blank"
                    rel="noopener noreferrer"
                    key="homepage__signup-marketing-link"
                  >
                    {t(
                      'HomePage.HomeSignup.FreePodcastingLinkText',
                      'share their voices',
                      'Why Anchor is free article link text'
                    )}
                  </MarketingAnchor>
                ),
              }
            )}
          </HomeSignupText>
          <HomeSignupButton>
            <MarketingButton
              kind="link"
              href={paths.anchor.signup}
              onClick={onClickGetStarted}
            >
              {t(
                'HomePage.HomeSignup.SignupLinkText',
                'Get started',
                'Sign up link text'
              )}
            </MarketingButton>
          </HomeSignupButton>
          {showSwitchLink && (
            <HomeSignupFooter>
              {t(
                'HomePage.HomeSignup.SwitchToAnchorMessage',
                'Already have a podcast? {switchLink}',
                'Switch to Anchor message',
                {
                  switchLink: (
                    <MarketingBoldLink
                      to={paths.anchor.switch}
                      onClick={onClickSwitch}
                      key="homepage__marketing-link-switch"
                    >
                      {t(
                        'HomePage.HomeSignup.SwitchToAnchorLinkText',
                        'Switch to Anchor',
                        'Switch to Anchor link text'
                      )}
                    </MarketingBoldLink>
                  ),
                }
              )}
            </HomeSignupFooter>
          )}
        </HomeSignupContainer>
      </HomeSection>
      {children}
    </HomeSignupBackground>
  );
}
